const heroImages = {
  categories: 'https://images.unsplash.com/photo-1589793463357-5fb813435467?auto=format&fit=crop&w=1600&q=80',
  requestSourcing: 'https://images.unsplash.com/photo-1631651693480-97f1132e333d?auto=format&fit=crop&w=1600&q=80',
  forBuyers: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1600&q=80',
  forSuppliers: 'https://images.unsplash.com/photo-1717386255773-1e3037c81788?auto=format&fit=crop&w=1600&q=80',
  howItWorks: 'https://images.pexels.com/photos/34718922/pexels-photo-34718922.jpeg?auto=compress&cs=tinysrgb&w=1600',
  services: 'https://images.unsplash.com/photo-1560264280-88b68371db39?auto=format&fit=crop&w=1600&q=80',
  about: 'https://images.unsplash.com/photo-1629652320041-c2c555e68101?auto=format&fit=crop&w=1600&q=80',
  contact: 'https://images.unsplash.com/photo-1648197685224-18c96a8d116d?auto=format&fit=crop&w=1600&q=80',
  blog: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=1600&q=80',
};

export default heroImages;
